import styled from '@emotion/styled';
import { Text } from 'components';

export const TabTitle = styled(Text)`

  font-weight: 600;
`;
